<template>
  <div ref="wrapper">
    <video ref="videoEl" style="width: 200px;"></video>
    <img
      :src="cutUrl"
      alt=""
      v-if="cutUrl"
      style="width: 200px; height: 200px;"
    />
    <div
      @click="shoot"
      class="w-100px leading-100px text-center bg-black text-30px"
    >
      拍摄
    </div>
    <div v-if="errMsg">errMsg: {{ errMsg }}</div>
    <div v-if="sideErrMsg">errMsg: {{ sideErrMsg }}</div>
    <button @click="closeCamera">关闭摄像头</button>
  </div>
</template>

<script>
import api from "@/utils/api";
import uploadHttp from "@/utils/picOnly";
import { getToken } from "@/utils/common";
export default {
  data() {
    return {
      MediaStreamTrack: "",
      cutUrl: "",
      errMsg: "",
      sideErrMsg: ""
    };
  },
  methods: {
    closeCamera() {
      this.MediaStreamTrack && this.MediaStreamTrack.stop();
    },
    async checkCamera() {
      try {
        if (window.navigator.mediaDevices == undefined) {
          window.navigator.mediaDevices = {};
        }
        const navigator = window.navigator;
        // 一些浏览器部分支持 mediaDevices。我们不能直接给对象设置 getUserMedia
        // 因为这样可能会覆盖已有的属性。这里我们只会在没有 getUserMedia 属性的时候添加它。
        if (navigator.mediaDevices.getUserMedia === undefined) {
          navigator.mediaDevices.getUserMedia = function(constraints) {
            // 首先，如果有 getUserMedia 的话，就获得它
            var getUserMedia =
              navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

            // 一些浏览器根本没实现它 - 那么就返回一个 error 到 promise 的 reject 来保持一个统一的接口
            if (!getUserMedia) {
              return Promise.reject(
                new Error("getUserMedia is not implemented in this browser")
              );
            }
            // 否则，为老的 navigator.getUserMedia 方法包裹一个 Promise
            return new Promise(function(resolve, reject) {
              getUserMedia.call(navigator, constraints, resolve, reject);
            });
          };
        }
        navigator.mediaDevices
          .getUserMedia({ audio: false, video: true })
          .then(stream => {
            var video = document.querySelector("video");
            // 旧的浏览器可能没有 srcObject
            if ("srcObject" in video) {
              video.srcObject = stream;
            } else {
              // 防止在新的浏览器里使用它，应为它已经不再支持了
              video.src = window.URL.createObjectURL(stream);
            }
            this.MediaStreamTrack =
              typeof stream.stop === "function"
                ? stream
                : stream.getTracks()[0];
            video.onloadedmetadata = function(e) {
              video.play();
            };
          })
          .catch(err => {
            this.errMsg = err;
            if (err == "NotAllowedError: Requested device not found") {
              // 该设备不支持
              alert("摄像头不可用");
            } else if (err == "NotAllowedError: Permission denied") {
              // 关闭了权限
              alert("摄像头未授权, 请前往设置页面");
            } else {
              alert(err);
            }
          });
      } catch (err) {
        this.sideErrMsg = err;
      }
    },

    shoot() {
      const canvas = document.createElement("canvas");
      canvas.width = this.$refs.videoEl.videoWidth;
      canvas.height = this.$refs.videoEl.videoHeight;
      //拿到 canvas 上下文对象
      const ctx = canvas.getContext("2d");
      ctx.drawImage(this.$refs.videoEl, 0, 0, canvas.width, canvas.height);
      this.cutUrl = canvas.toDataURL("image/png");
      // this.$refs.wrapper.appendChild(canvas);
    },
    upload(canvas) {
      canvas.toBlob(blob => {
        try {
          var url = api.question.upload;
          let formData = new window.FormData();
          formData.append("file", blob);
          formData.append("access_token", getToken());
          uploadHttp.post(url, formData).then(res => {
            this.$store.commit("changeLoading", { status: false });
          });
        } catch (e) {
          this.$store.commit("changeLoading", { status: false });
        }
      });
    }
  },
  mounted() {
    this.checkCamera();
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/demo/demo.vue